import { gql, graphQueryBang } from "shared/lib/graphql"

const StepFragment = `
  id
  name
  module_name
  description
  weight
`

const replaceFragments = query => query.replace(/STEP_FRAGMENT/g, StepFragment)

const StepsQuery = replaceFragments(gql`
  query($channel_module_name: String!) {
    channel(module_name: $channel_module_name) {
      actions {
        STEP_FRAGMENT
      }

      queries {
        STEP_FRAGMENT
      }

      triggers {
        STEP_FRAGMENT
      }
    }
  }
`)

export function loadServiceSteps(service) {
  return graphQueryBang(StepsQuery, {
    channel_module_name: service.module_name || service.slug,
  }).then(data => {
    return {
      triggers: data.channel.triggers,
      actions: data.channel.actions,
      queries: data.channel.queries,
    }
  })
}
